import { render } from "./ClienteList.vue?vue&type=template&id=1d3859ac&scoped=true"
import script from "./ClienteList.vue?vue&type=script&lang=js"
export * from "./ClienteList.vue?vue&type=script&lang=js"

import "./ClienteList.vue?vue&type=style&index=0&id=1d3859ac&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3859ac"]])

export default __exports__